import React, { useEffect, useMemo, useRef, useState } from 'react';
import icArrowUp1 from 'Assets/img/header/ic_gray_up_arrow.png';
import icArrowUp2 from 'Assets/img/header/ic_gray_up_arrow@2x.png';
import icArrowUp3 from 'Assets/img/header/ic_gray_up_arrow@3x.png';
import icLogout1 from 'Assets/img/header/ic_logout.png';
import icLogout2 from 'Assets/img/header/ic_logout@2x.png';
import icLogout3 from 'Assets/img/header/ic_logout@3x.png';
import icSettingLine1 from 'Assets/img/header/ic_setting_line.png';
import icSettingLine2 from 'Assets/img/header/ic_setting_line@2x.png';
import icSettingLine3 from 'Assets/img/header/ic_setting_line@3x.png';
import icPencil1 from 'Assets/img/header/ic_pencil_666_10.png';
import icPencil2 from 'Assets/img/header/ic_pencil_666_10@2x.png';
import icPencil3 from 'Assets/img/header/ic_pencil_666_10@3x.png';
import { useDispatch, useSelector } from 'react-redux';
import { getImageSet } from 'Util/DataUtils';
import { formatBusinessNumber } from 'Util/NumberUtils';
import { useNavigate } from 'react-router-dom';
import IntlMessages from 'Util/IntlMessages';
import { logoutUser, updateMe } from 'Actions/AuthActions';
import { useIntl } from 'react-intl';
import emptyProfile1 from 'Assets/img/empty_profile.png';
import emptyProfile2 from 'Assets/img/empty_profile@2x.png';
import emptyProfile3 from 'Assets/img/empty_profile@3x.png';
import { useError } from 'Api/hooks/useError';
import { me, patchProfileImage, uploadFileProfileImage } from 'Api/endpoints/Auth';

const icArrowUp = getImageSet([icArrowUp1, icArrowUp2, icArrowUp3]);
const icLogout = getImageSet([icLogout1, icLogout2, icLogout3]);
const icSettingLine = getImageSet([icSettingLine1, icSettingLine2, icSettingLine3]);
const icPencil = getImageSet([icPencil1, icPencil2, icPencil3]);
const emptyProfile = getImageSet([emptyProfile1, emptyProfile2, emptyProfile3]);

const UserBlock = () => {
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const [isOpenedUserBlock, setIsOpenedUserBlock] = useState(false);
  const { user } = useSelector(state => state.authUser);
  const blockRef = useRef(null);
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const inputRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorPopup } = useError();

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpenedUserBlock(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpenedUserBlock]);

  const getUserName = () => {
    if (user.isStaff) {
      return user.partner.materialBuyer.staffs.name;
    } else {
      return user.name;
    }
  };

  const getNumber = () => {
    if (user.isStaff) {
      return `${formatMessage({ id: 'staff.no' })} ${user.partner.materialBuyer.staffs.id}`;
    } else {
      return formatBusinessNumber(user.phone);
    }
  };

  const profileImage = useMemo(() => {
    if (user.isStaff) {
      return user?.partner?.materialBuyer?.staffs?.profileImage;
    }
    return user?.partner?.materialBuyer?.profileImage;
  }, [user]);

  const setProfileImage = async ({ file }) => {
    if (isLoading) return;

    try {
      setIsLoading(true);
      const result = await uploadFileProfileImage(file);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return null;
      }
      const patchResult = await patchProfileImage({ profileImage: result.data.image.origin_path });
      if (patchResult.err) {
        showErrorPopup({ text: patchResult.err.response.data.message });
        return null;
      }
      const resultMe = await me();
      if (resultMe.err) {
        showErrorPopup({ text: resultMe.err.response.data.message });
        return null;
      }
      dispatch(updateMe(resultMe.data));
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div ref={dropdownRef} className="header-user-button no-drag cursor-pointer" onClick={() => setIsOpenedUserBlock(x => !x)}>
      <img {...(profileImage ? { src: profileImage } : emptyProfile)} alt="empty-profile" className="profile-image" />
      <div>{getUserName()}</div>
      <img {...icArrowUp} alt="arrow" style={{ transform: 'rotate(180deg)' }} />
      <div className="header-user-block" ref={blockRef} style={{ ...(!isOpenedUserBlock && { visibility: 'hidden' }), bottom: (blockRef?.current?.clientHeight + 5) * -1 || 0 }}>
        <div className="block-top">
          <div className="block-top-image">
            <div style={{ width: '50px', height: '50px', overflow: 'hidden', borderRadius: '8px', border: '1px solid #eee' }}>
              <img {...(profileImage ? { src: profileImage } : emptyProfile)} alt="empty-profile" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
            </div>
            <div className="block-top-image-pencil cursor-pointer">
              <img
                {...icPencil}
                alt="pencil"
                onClick={() => {
                  inputRef.current.click();
                }}
              />
              <input type="file" ref={inputRef} onChange={e => setProfileImage({ file: e.target.files[0] })} accept="image/*" style={{ display: 'none' }} />
            </div>
          </div>
          <div className="block-top-title">
            <div className="block-top-name">{getUserName()}</div>
            <div className="block-top-number">{getNumber()}</div>
          </div>
        </div>
        <div className="divider" />
        <div
          className="block-bottom cursor-pointer"
          onClick={() => {
            navigate('/admin/setting/me');
          }}
        >
          <img {...icSettingLine} alt="setting" />
          <div>
            <IntlMessages id="title.setting" />
          </div>
        </div>
        <div className="block-bottom cursor-pointer" onClick={() => dispatch(logoutUser())}>
          <img {...icLogout} alt="logout" />
          <div>
            <IntlMessages id="common.logout" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBlock;
